import { Mutations } from '@/util/settings/enums';
const mutations = {
    [Mutations.SET_AUTH_DATA](state, { authEmail, doctorId, connectId }) {
        state.user.authEmail = authEmail;
        state.user.doctorId = doctorId;
        state.user.connectId = connectId;
        state.isAuthDataSet = true;
    },
    [Mutations.SET_IS_AUTHENTICATED](state, payload) {
        state.isAuthenticated = payload;
    }
};
export default mutations;
